import Decision from 'slotworks/state-machine/decisions/decision';
import { Exit } from 'slotworks/state-machine/data/exit';
import gameState from 'slotworks/model/game-state';
import BuyoutRecord from 'integration/records/buyout-record';

export default class IsBuyout extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if(record instanceof BuyoutRecord) {
            return Exit.True;    
        }
        
        return Exit.False;
    }
}
